import { FC } from "react";
import { TMessage } from "../../i18n/tt";
import symbolPrimary from "../../assets/img/brand/symbolPrimary.svg";
import { observer } from "mobx-react";
import { Alert } from "../../components-v2/Alert";
import { Button, LinkButton } from "../../components-v2/Button";
import { isFailure, isPending, Result } from "../../common/common";
import { MTextInput } from "../../components-v2/TextInput";
import { Box, VBox } from "../../components-v2/Box";

import { useTranslation } from "../../stores/RootStoreContext";
import { StringFieldModel } from "../../common/commonForms";

export const Header: FC = () => {
  const { t } = useTranslation();
  return (
    <VBox marginTop={"lg"}>
      <h1>
        <Box>
          <img src={symbolPrimary} alt="dCompany" className={"tw-w-16"} />
          {t("user-settings.create-password")}
        </Box>
      </h1>
    </VBox>
  );
};

export const SuccessView: FC<{ navigateToLogin: () => void }> = observer(({ navigateToLogin }) => {
  const { t } = useTranslation();
  return (
    <VBox gap={"md"}>
      <Alert type={"success"} message={t("user-settings.create-password-success-message")} />
      <Box justifyContent={"end"}>
        <LinkButton
          label={t("user-settings.take-me-to-the-login-page")}
          onClick={navigateToLogin}
          arrow={"right"}
        />
      </Box>
    </VBox>
  );
});

export const CreatePasswordView: FC<{
  username: StringFieldModel;
  password: StringFieldModel;
  confirmedPassword: StringFieldModel;
  save: () => void;
  result?: Result<void, TMessage>;
}> = observer(({ result, username, password, confirmedPassword, save }) => {
  const { t } = useTranslation();
  return (
    <VBox gap={"md"}>
      {isFailure(result) && <Alert type={"error"} message={t(result.error)} />}
      <MTextInput model={username} label={t("user-settings.username")} autofocus />
      <MTextInput model={password} label={t("user-settings.password")} type={"password"} />
      <MTextInput
        model={confirmedPassword}
        label={t("user-settings.confirm-password")}
        type={"password"}
      />
      <Button
        variant={"primary"}
        label={t("submit")}
        loading={isPending(result)}
        disabled={isPending(result)}
        onClick={save}
      />
    </VBox>
  );
});
